import cubo2x2normal from "../Images/cubo3x3normal.svg"
import cubo3x3normal from "../Images/cubo3x3normal.svg"
export default class UC{

    static getDefaultSingle(){
        return this.getCategoriasSingle()[0];
    }

    static getDefaultAvg(){
        return this.getCategoriasAvg()[0];
    }

    static getPosSg(cat){
        let cats = UC.getCategoriasSingle();
        let pos = 0;
        for(let i=0;i<cats.length;i++){
            if(cats[i].id===cat.id){
                pos = i;
                i = cats.length;
            }
        }
        return pos;
    }

    static getCategoriasSingle(){
        var categorias = [];
        categorias.push({
            id: "Cubo3x3x3Normal",
            nombre: "Cubo 3x3x3",
            imagen: cubo3x3normal,
            tipo: "CUBO3X3",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo2x2x2Normal",
            nombre: "Cubo 2x2x2",
            imagen: cubo2x2normal,
            tipo: "CUBO2X2",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo4x4x4Normal",
            nombre: "Cubo 4x4x4",
            imagen: cubo3x3normal,
            tipo: "CUBO4X4",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo5x5x5Normal",
            nombre: "Cubo 5x5x5",
            imagen: cubo2x2normal,
            tipo: "CUBO5X5",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo6x6x6Normal",
            nombre: "Cubo 6x6x6",
            imagen: cubo3x3normal,
            tipo: "CUBO6X6",
            variante: "NORMAL",
            solves: 3
        });

        categorias.push({
            id: "Cubo7x7x7Normal",
            nombre: "Cubo 7x7x7",
            imagen: cubo2x2normal,
            tipo: "CUBO7X7",
            variante: "NORMAL",
            solves: 3
        });

        categorias.push({
            id: "Cubo3x3x3Ciega",
            nombre: "3x3x3 Ciega",
            imagen: cubo3x3normal,
            tipo: "CUBO3X3",
            variante: "BLIND",
            solves: 3
        });

        categorias.push({
            id: "Cubo3x3x3UnaMano",
            nombre: "3x3x3 Una Mano",
            imagen: cubo2x2normal,
            tipo: "CUBO3X3",
            variante: "ONEHAND",
            solves: 5
        });

        categorias.push({
            id: "ClockNormal",
            nombre: "Clock",
            imagen: cubo3x3normal,
            tipo: "CLOCK",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "MegaminxNormal",
            nombre: "Megaminx",
            imagen: cubo2x2normal,
            tipo: "MEGAMINX",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "PyraminxNormal",
            nombre: "Pyraminx",
            imagen: cubo2x2normal,
            tipo: "PYRAMINX",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "SkewbNormal",
            nombre: "Skewb",
            imagen: cubo2x2normal,
            tipo: "SKEWB",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "Square_1Normal",
            nombre: "Square-1",
            imagen: cubo2x2normal,
            tipo: "SQUARE1",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "Cubo4x4x4Ciega",
            nombre: "4x4x4 Ciega",
            imagen: cubo2x2normal,
            tipo: "CUBO4X4",
            variante: "BLIND",
            solves: 3
        });
        categorias.push({
            id: "Cubo5x5x5Ciega",
            nombre: "5x5x5 Ciega",
            imagen: cubo2x2normal,
            tipo: "CUBO5X5",
            variante: "BLIND",
            solves: 3
        });

        return categorias;
    }

    static getCategoriasAvg(){
        var categorias = [];
        categorias.push({
            id: "Cubo3x3x3NormalAVG",
            nombre: "Cubo 3x3x3",
            imagen: cubo3x3normal,
            tipo: "CUBO3X3",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo2x2x2NormalAVG",
            nombre: "Cubo 2x2x2",
            imagen: cubo2x2normal,
            tipo: "CUBO2X2",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo4x4x4NormalAVG",
            nombre: "Cubo 4x4x4",
            imagen: cubo3x3normal,
            tipo: "CUBO4X4",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo5x5x5NormalAVG",
            nombre: "Cubo 5x5x5",
            imagen: cubo2x2normal,
            tipo: "CUBO5X5",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "Cubo6x6x6NormalAVG",
            nombre: "Cubo 6x6x6",
            imagen: cubo3x3normal,
            tipo: "CUBO6X6",
            variante: "NORMAL",
            solves: 3
        });

        categorias.push({
            id: "Cubo7x7x7NormalAVG",
            nombre: "Cubo 7x7x7",
            imagen: cubo2x2normal,
            tipo: "CUBO7X7",
            variante: "NORMAL",
            solves: 3
        });

        categorias.push({
            id: "Cubo3x3x3CiegaAVG",
            nombre: "3x3x3 Ciega",
            imagen: cubo3x3normal,
            tipo: "CUBO3X3",
            variante: "BLIND",
            solves: 3
        });

        categorias.push({
            id: "Cubo3x3x3UnaManoAVG",
            nombre: "3x3x3 Una Mano",
            imagen: cubo2x2normal,
            tipo: "CUBO3X3",
            variante: "ONEHAND",
            solves: 5
        });

        categorias.push({
            id: "ClockNormalAVG",
            nombre: "Clock",
            imagen: cubo3x3normal,
            tipo: "CLOCK",
            variante: "NORMAL",
            solves: 5
        });

        categorias.push({
            id: "MegaminxNormalAVG",
            nombre: "Megaminx",
            imagen: cubo2x2normal,
            tipo: "MEGAMINX",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "PyraminxNormalAVG",
            nombre: "Pyraminx",
            imagen: cubo2x2normal,
            tipo: "PYRAMINX",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "SkewbNormalAVG",
            nombre: "Skewb",
            imagen: cubo2x2normal,
            tipo: "SKEWB",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "Square_1NormalAVG",
            nombre: "Square-1",
            imagen: cubo2x2normal,
            tipo: "SQUARE1",
            variante: "NORMAL",
            solves: 5
        });
        categorias.push({
            id: "Cubo4x4x4CiegaAVG",
            nombre: "4x4x4 Ciega",
            imagen: cubo2x2normal,
            tipo: "CUBO4X4",
            variante: "BLIND",
            solves: 3
        });
        categorias.push({
            id: "Cubo5x5x5CiegaAVG",
            nombre: "5x5x5 Ciega",
            imagen: cubo2x2normal,
            tipo: "CUBO5X5",
            variante: "BLIND",
            solves: 3
        });

        return categorias;
    }

    static getPosCatSingle(key) {
        let res = -1;

        let categorias = UC.getCategoriasSingle();

        for(let i=0; i<categorias.length; i++){
            if(key===categorias[i].id){
                res = i;
            }
        }
        return res;
    }

    static getPosCatAverage(key) {
        let res = -1;

        let categorias = UC.getCategoriasAvg();

        for(let i=0; i<categorias.length; i++){
            if(key===categorias[i].id){
                res = i;
            }
        }
        return res;
    }
}